import type { PreferenceUpdateRequest, PreferencesResponse } from "../types";

const API_BASE = "/api";

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      "content-type": "application/json",
      ...(init?.headers ?? {})
    }
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = payload.message ?? "Request failed";
    throw new Error(message);
  }
  return payload as T;
}

export const api = {
  getPreferences(): Promise<PreferencesResponse> {
    return request<PreferencesResponse>("/preferences");
  },
  updatePreferences(body: PreferenceUpdateRequest): Promise<PreferencesResponse> {
    return request<PreferencesResponse>("/preferences", {
      method: "PUT",
      body: JSON.stringify(body)
    });
  },
  acceptPrivacyDisclosure(): Promise<PreferencesResponse> {
    return request<PreferencesResponse>("/privacy-disclosure", { method: "POST" });
  },
  updateContact(channel: string, destination: string): Promise<PreferencesResponse> {
    return request<PreferencesResponse>("/contact", {
      method: "PUT",
      body: JSON.stringify({ channel, destination })
    });
  },
  deleteContact(): Promise<PreferencesResponse> {
    return request<PreferencesResponse>("/contact", { method: "DELETE" });
  },
  unlink(): Promise<{ status: string }> {
    return request<{ status: string }>("/unlink", { method: "POST" });
  },
  joinWaitlist(emailAddress: string): Promise<{ status: string; source: string }> {
    return request<{ status: string; source: string }>("/waitlist", {
      method: "POST",
      body: JSON.stringify({ email_address: emailAddress, source: "capacity_full" })
    });
  }
};
